import React, { FunctionComponent, useEffect, useRef } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { ErrorMessage, ProductFormFieldChangeHandler } from '../../../../../types/interfaces';
import { getTextFactoryReturnType } from '../../../../../utils/TextUtils';
import { ProductFormCheckbox, ProductFormInput, ProductFormSelect } from '../../../../../components/productFormFields';
import { filterFirmEmployeeRelationTypes } from '../constants';
import { fullNameRegex } from '../../../../../utils/regex';

type FamilyFirmEmployeeFormGroupProps = {
  getText: getTextFactoryReturnType;
  change: ProductFormFieldChangeHandler;
  getGlobalText: getTextFactoryReturnType;
  formatErrorMessage: (error: ErrorMessage) => string;
  familyInvestmentFirmEmployeeInd?: boolean;
};

const FamilyFirmEmployeeFormGroup: FunctionComponent<FamilyFirmEmployeeFormGroupProps> = (
  props: FamilyFirmEmployeeFormGroupProps,
) => {
  const { getText, getGlobalText, formatErrorMessage, familyInvestmentFirmEmployeeInd, change } = props;
  const prevFamilyInvestmentFirmEmployeeIndRef = useRef<boolean | undefined>(familyInvestmentFirmEmployeeInd);

  // Clear dependent fields when checkbox is unchecked
  useEffect(() => {
    const prevValue = prevFamilyInvestmentFirmEmployeeIndRef.current;
    if (prevValue === true && familyInvestmentFirmEmployeeInd === false) {
      change('proInvolvement.familyInvestmentFirmEmployeeTypeCd', null);
      change('proInvolvement.familyInvestmentFirmEmployeeFullName', null);
    }
    prevFamilyInvestmentFirmEmployeeIndRef.current = familyInvestmentFirmEmployeeInd;
  }, [familyInvestmentFirmEmployeeInd, change]);

  return (
    <>
      <Col xs={12} md={4} lg={3} data-test="field_familyInvestmentFirmEmployeeInd">
        <ProductFormCheckbox
          className="checkbox-form"
          label={getText('yourFamilyCheckbox')}
          name="proInvolvement.familyInvestmentFirmEmployeeInd"
          formatErrorMessage={formatErrorMessage}
        />
      </Col>

      {familyInvestmentFirmEmployeeInd && (
        <Col sm={12} md={7} lg={8}>
          <Row className="mb-6 answer">
            <Col xs={12} md={12} data-test="field_familyInvestmentFirmEmployeeTypeCd">
              <ProductFormSelect
                name="proInvolvement.familyInvestmentFirmEmployeeTypeCd"
                placeholder={getGlobalText('select')}
                label={getText('proInvolvementRelation')}
                formatErrorMessage={formatErrorMessage}
                filter={filterFirmEmployeeRelationTypes}
              />
            </Col>
            <Col xs={12} md={12} data-test="field_familyInvestmentFirmEmployeeFullName">
              <ProductFormInput
                className="mb-3"
                maxLength={254}
                name="proInvolvement.familyInvestmentFirmEmployeeFullName"
                regex={fullNameRegex}
                label={getText('personName')}
                formatErrorMessage={formatErrorMessage}
              />
            </Col>
          </Row>
        </Col>
      )}
    </>
  );
};

export default FamilyFirmEmployeeFormGroup;
